/**
 * Convierte un string arbitrario en un nombre de archivo seguro.
 * - Normaliza caracteres con tilde (á → a, ñ → n, etc.)
 * - Reemplaza espacios y caracteres especiales por guiones
 * - Colapsa guiones consecutivos
 * - Limita a maxLength caracteres
 * - Elimina guiones al inicio y al final
 */
export function sanitizeFileName(input: string, maxLength = 50): string {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')   // elimina diacríticos
    .replace(/[^a-zA-Z0-9\s-]/g, ' ') // caracteres especiales → espacio
    .trim()
    .replace(/[\s]+/g, '-')            // espacios → guiones
    .replace(/-{2,}/g, '-')            // colapsa guiones dobles
    .slice(0, maxLength)
    .replace(/^-+|-+$/g, '')           // elimina guiones al inicio/fin
}

/**
 * Construye el nombre del archivo ZIP TE1 a partir del nombre o dirección del proyecto.
 * Prioriza la dirección si está disponible, recae en el nombre del proyecto.
 * Formato: TE1-{slug}.zip
 */
export function buildZipFileName(projectName: string, projectAddress?: string | null): string {
  const label = (projectAddress?.trim() || projectName?.trim()) ?? ''
  const slug = label ? sanitizeFileName(label) : ''
  return slug ? `TE1-${slug}.zip` : 'TE1-documentos.zip'
}
